// extracted by mini-css-extract-plugin
module.exports = {"moniker":"Validators_moniker__3TbU4","muted":"Validators_muted__NQjhc","tooltip":"Validators_tooltip__1QgmE","dlGap":"Validators_dlGap__1pIlu"};